import { cn } from "@/lib/utils";
import { Skeleton } from "@/shared/components/ui/skeleton";
import { formatNumber } from "../processed-sources";

export default function CardTabs({
  isLoading,
  pdfDocumentCount,
  webSourcesCount,
  hoursOfWatch,
  pageReadCount,
  multimediaVideosCount
}: {
  isLoading: boolean;
  pdfDocumentCount: number;
  webSourcesCount: number;
  hoursOfWatch: number;
  pageReadCount: number;
  multimediaVideosCount: number;
}) {
  return (
    <div className="flex gap-[16px] w-full px-[20px] mb-[24px]">
      <div
        className={cn(
          "h-[130px] flex-1 cursor-pointer rounded-[12px] border border-[#e4e4e7] p-[16px] relative",
        )}
      >
        <div>
          <div className="text-[14px] font-600 text-[#3F3F46] mb-[6px]">
            PDF & Döküman
          </div>
          <div className="font-[Inter] font-700 text-[20px] text-[#09090B]">
            {isLoading ? <Skeleton className="w-[60px] h-[26px] mt-[10px]" /> : formatNumber(pdfDocumentCount)}
          </div>
        </div>
        <div className="flex gap-[4px] h-[28px] items-center pt-[8px] border-t border-[#ececec] mt-[16px]">
          <div className="size-[12px] rounded-full border-2 border-white shadow-sm bg-[#F9CF6C]"></div>
          <div className="text-[12px] text-[#3F3F46] font-700">{isLoading ? <Skeleton className="w-[20px] h-[10px]" /> : formatNumber(pageReadCount)}</div>
          <div className="text-[12px] text-[#3F3F46] font-600">{isLoading ? <Skeleton className="w-[20px] h-[10px]" /> : "sayfa okuma"}</div>
        </div>
        <div className="absolute top-[13px] right-[14px]">
          <div className="size-[40px] bg-white rounded-full flex items-center justify-center border border-[#e4e4e7]">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_17704_116032)">
                <path
                  d="M2.66667 14.6668H12C12.3536 14.6668 12.6928 14.5264 12.9428 14.2763C13.1929 14.0263 13.3333 13.6871 13.3333 13.3335V4.66683L10 1.3335H4C3.64638 1.3335 3.30724 1.47397 3.05719 1.72402C2.80714 1.97407 2.66667 2.31321 2.66667 2.66683V5.3335M9.33333 1.3335V4.00016C9.33333 4.35378 9.47381 4.69292 9.72386 4.94297C9.97391 5.19302 10.313 5.3335 10.6667 5.3335H13.3333M2 10.0002L3.33333 11.3335L6 8.66683"
                  stroke="#09090B"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_17704_116032">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>
      <div
        className={cn(
          "h-[130px] flex-1 cursor-pointer rounded-[12px] border border-[#e4e4e7] p-[16px] relative",
        )}
      >
        <div>
          <div className="text-[14px] font-600 text-[#3F3F46] mb-[6px]">
            Web Kaynakları
          </div>
          <div className="font-[Inter] font-700 text-[20px] text-[#09090B]">
            {isLoading ? <Skeleton className="w-[60px] h-[26px] mt-[10px]" /> : formatNumber(webSourcesCount)}
          </div>
        </div>
        <div className="flex gap-[4px] h-[28px] items-center pt-[8px] border-t border-[#ececec] mt-[16px]">
          <div className="size-[12px] rounded-full border-2 border-white shadow-sm bg-[#F7876B]"></div>
          <div className="text-[12px] text-[#3F3F46] font-700">{isLoading ? <Skeleton className="w-[20px] h-[10px]" /> : formatNumber(pageReadCount)} </div>
          <div className="text-[12px] text-[#3F3F46] font-600">
            {isLoading ? <Skeleton className="w-[20px] h-[10px]" /> : "saat araştırma"}
          </div>
        </div>
        <div className="absolute top-[13px] right-[14px]">
          <div className="size-[40px] bg-white rounded-full flex items-center justify-center border border-[#e4e4e7]">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_17704_116039)">
                <path
                  d="M14.36 10.0002H11.3334C10.9798 10.0002 10.6406 10.1406 10.3906 10.3907C10.1405 10.6407 10 10.9799 10 11.3335V14.3602M4.66671 2.22689V3.33355C4.66671 3.86399 4.87742 4.3727 5.25249 4.74777C5.62757 5.12284 6.13627 5.33355 6.66671 5.33355C7.02033 5.33355 7.35947 5.47403 7.60952 5.72408C7.85956 5.97413 8.00004 6.31327 8.00004 6.66689C8.00004 7.40022 8.60004 8.00022 9.33337 8.00022C9.687 8.00022 10.0261 7.85974 10.2762 7.6097C10.5262 7.35965 10.6667 7.02051 10.6667 6.66689C10.6667 5.93355 11.2667 5.33355 12 5.33355H14.1134M7.33341 14.6335V12.0002C7.33341 11.6465 7.19293 11.3074 6.94288 11.0574C6.69283 10.8073 6.35369 10.6668 6.00007 10.6668C5.64645 10.6668 5.30731 10.5264 5.05726 10.2763C4.80722 10.0263 4.66674 9.68712 4.66674 9.3335V8.66683C4.66674 8.31321 4.52626 7.97407 4.27622 7.72402C4.02617 7.47397 3.68703 7.3335 3.33341 7.3335H1.36674M14.6667 8.00016C14.6667 11.6821 11.6819 14.6668 8.00004 14.6668C4.31814 14.6668 1.33337 11.6821 1.33337 8.00016C1.33337 4.31826 4.31814 1.3335 8.00004 1.3335C11.6819 1.3335 14.6667 4.31826 14.6667 8.00016Z"
                  stroke="#09090B"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_17704_116039">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>
      <div
        className={cn(
          "h-[130px] flex-1 cursor-pointer rounded-[12px] border border-[#e4e4e7] p-[16px] relative",
        )}
      >
        <div>
          <div className="text-[14px] font-600 text-[#3F3F46] mb-[6px]">
            Multimedia
          </div>
          <div className="font-[Inter] font-700 text-[20px] text-[#09090B]">
            {isLoading ? <Skeleton className="w-[60px] h-[26px] mt-[10px]" /> : formatNumber(multimediaVideosCount)}
          </div>
        </div>
        <div className="flex gap-[4px] h-[35px] items-center p-[8px] border-t border-[##ececec] mt-[16px]">
          <div className="size-[12px] rounded-full border-2 border-white shadow-sm bg-[#F76B6D]"></div>
          <div className="text-[12px] text-[#3F3F46] font-700">{isLoading ? <Skeleton className="w-[20px] h-[10px] mt-[4px]" /> : formatNumber(hoursOfWatch)} </div>
          <div className="text-[12px] text-[#3F3F46] font-600">{isLoading ? <Skeleton className="w-[40px] h-[10px] mt-[4px]" /> : "saat izleme"}</div>
        </div>
        <div className="absolute top-[13px] right-[14px]">
          <div className="size-[40px] bg-white rounded-full flex items-center justify-center border border-[#e4e4e7]">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.66667 11.3333C1.20095 9.13551 1.20095 6.86449 1.66667 4.66667C1.72786 4.44347 1.8461 4.24005 2.00974 4.0764C2.17339 3.91276 2.37681 3.79453 2.6 3.73333C6.17564 3.14097 9.82437 3.14097 13.4 3.73333C13.6232 3.79453 13.8266 3.91276 13.9903 4.0764C14.1539 4.24005 14.2721 4.44347 14.3333 4.66667C14.7991 6.86449 14.7991 9.13551 14.3333 11.3333C14.2721 11.5565 14.1539 11.7599 13.9903 11.9236C13.8266 12.0872 13.6232 12.2055 13.4 12.2667C9.82438 12.8591 6.17563 12.8591 2.6 12.2667C2.37681 12.2055 2.17339 12.0872 2.00974 11.9236C1.8461 11.7599 1.72786 11.5565 1.66667 11.3333Z"
                stroke="#09090B"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M6.66667 10L10 8L6.66667 6V10Z"
                stroke="#09090B"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}
